export default "__VITE_ASSET__CjGg5PLr__"